import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { css } from "@emotion/css";
// Standalone helper - doesn't need component context
const handleKeyDown = (event, action) => {
    if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        action(event);
    }
};
const styles = {
    blockContainer: css `
    background: #ccc;
    position: relative;
  `,
    // Pause button in form of overlay layer
    pauseButton: css `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `,
    playButton: css `
    border-radius: 76px;
    width: 76px;
    height: 76px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  `,
};
export class MinimalPlayer extends React.Component {
    constructor() {
        super(...arguments);
        this.videoRef = React.createRef();
        this.state = {
            playing: false,
        };
        this.handleVideoPlaybackStart = () => {
            this.setState({ playing: true });
        };
        this.handleVideoPlaybackPaused = () => {
            this.setState({ playing: false });
        };
        this.handleVideoPlaybackFinished = () => {
            if (this.props.onEnd) {
                this.props.onEnd();
            }
        };
        this.play = event => {
            event.stopPropagation();
            if (this.videoRef.current) {
                this.videoRef.current.play();
            }
        };
        this.pause = event => {
            event.stopPropagation();
            if (this.videoRef.current) {
                this.videoRef.current.pause();
            }
        };
    }
    componentDidMount() {
        if (this.videoRef.current) {
            this.videoRef.current.addEventListener("play", this.handleVideoPlaybackStart);
            this.videoRef.current.addEventListener("pause", this.handleVideoPlaybackPaused);
            this.videoRef.current.addEventListener("ended", this.handleVideoPlaybackFinished);
        }
    }
    componentWillUnmount() {
        if (this.videoRef.current) {
            this.videoRef.current.removeEventListener("play", this.handleVideoPlaybackStart);
            this.videoRef.current.removeEventListener("pause", this.handleVideoPlaybackPaused);
            this.videoRef.current.removeEventListener("ended", this.handleVideoPlaybackFinished);
        }
    }
    render() {
        // Destructure source and onEnd to exclude them from videoElementProps
        // source is used directly via this.props.source, onEnd is used in handleVideoPlaybackFinished
        const { source: _source, onEnd: _onEnd, ...videoElementProps } = this.props;
        return (_jsxs("div", { className: styles.blockContainer, style: { width: this.props.width, height: this.props.height }, children: [_jsxs("video", { ref: this.videoRef, ...videoElementProps, children: [_jsx("source", { src: this.props.source }), _jsx("track", { kind: "captions" })] }), _jsx("div", { className: styles.pauseButton, role: "button", tabIndex: 0, onClick: this.pause, onKeyDown: e => handleKeyDown(e, this.pause), children: this.state.playing === false && (_jsx("div", { className: styles.playButton, role: "button", tabIndex: 0, onClick: this.play, onKeyDown: e => handleKeyDown(e, this.play), "data-test-id": "mandatory-video-block-play-button", children: _jsx("img", { className: "image-button-play", width: "76", height: "76", alt: "" }) })) })] }));
    }
}
